import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { getBusinessConfigurations, updateBusinessConfigurations } from "../../store/reducers/GeneralSlice";
import { selectBusinessConfigurations } from "../../store/selectors";
import { Box, Button, Grid, InputLabel, MenuItem, Select, TextField, useTheme } from "@material-ui/core";
import useGeneralStyle from "../../assets/css/general";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";

const Configurations = () => {
    const params = useLocation();
    const location = useLocation();
    const dispatch = useDispatch();
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const configurations = useSelector(selectBusinessConfigurations);
    const globalClasses = useGeneralStyle();
    const history = useHistory();
    const theme = useTheme();
    const notification = useSnackbar();

    useEffect(() => {
        dispatch(getBusinessConfigurations({
            business_id: searchParams.get('business_id')
        }))
    }, [])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            billing_format: configurations?.billing_format || "",
            inventory_manageable: configurations?.inventory_manageable || "",
            tax_scheme: configurations?.tax_scheme || "",
            delivery_mode: configurations?.delivery_mode || "",
            business_type: configurations?.business_type || "",
            address_checkout: configurations?.address_checkout || "",
            whatsapp_vendor: configurations?.whatsapp_vendor || "",
            currency: configurations?.currency || "",
            login_type: configurations?.login_type || "",
            is_cod_enabled: configurations?.is_cod_enabled ? "1" : "0",
            ycloud_key: configurations?.ycloud_key || "",
            is_gateway_enabled: configurations?.is_gateway_enabled || "",
        },
        onSubmit: (values) => {
            dispatch(updateBusinessConfigurations({
                business_id: searchParams.get('business_id'),
                ...values,
                callback: (data) => {
                    notification.enqueueSnackbar("Configurations updated successfully", {
                        variant: "success",
                    });
                }
            }))
        },
    })

    return <>
        <Grid container style={{ padding: theme.spacing(3) }}>
            <Grid item xs={12}>
                <Box display="flex" flex={1}>
                    <Box flex={1}>
                        <Button
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            <ArrowBackIosIcon /> Back
                        </Button>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={formik.handleSubmit}
                        >
                            Modify
                        </Button>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Billing Format
                </InputLabel>
                <Select
                    name="billing_format"
                    value={formik.values.billing_format}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="detailed">Detailed</MenuItem>
                    <MenuItem value="compact">Compact</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Inventory Manageable
                </InputLabel>
                <Select
                    name="inventory_manageable"
                    value={formik.values.inventory_manageable}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="true">Yes</MenuItem>
                    <MenuItem value="false">No</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Tax Scheme
                </InputLabel>
                <Select
                    name="tax_scheme"
                    value={formik.values.tax_scheme}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="regular">Regular</MenuItem>
                    <MenuItem value="composition">Composition</MenuItem>
                    <MenuItem value="regular_without_showing_gst">Regular Without Showing GST</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Delivery Mode
                </InputLabel>
                <Select
                    name="delivery_mode"
                    value={formik.values.delivery_mode}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="slot_based">Slot Based</MenuItem>
                    <MenuItem value="estimated_date">Estimated Date</MenuItem>
                    <MenuItem value="same_day">Same Day</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Business Type
                </InputLabel>
                <Select
                    name="business_type"
                    value={formik.values.business_type}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="store">store</MenuItem>
                    <MenuItem value="restaurant">restaurant</MenuItem>
                    <MenuItem value="services">Services</MenuItem>
                    <MenuItem value="inquery">Inquery</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Address Checkout
                </InputLabel>
                <Select
                    name="address_checkout"
                    value={formik.values.address_checkout}
                    onChange={formik.handleChange}
                >
                    <MenuItem value={'Y'}>Yes</MenuItem>
                    <MenuItem value={"N"}>No</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    WhatsApp Service Vendor
                </InputLabel>
                <Select
                    name="whatsapp_vendor"
                    value={formik.values.whatsapp_vendor}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="msg91">MSG 91</MenuItem>
                    <MenuItem value="ycloud">YCloud</MenuItem>
                    <MenuItem value="stewindia">Stew India</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Currency
                </InputLabel>
                <Select
                    name="currency"
                    value={formik.values.currency}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="INR">INR</MenuItem>
                    <MenuItem value="USD">USD</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Login Type
                </InputLabel>
                <Select
                    name="login_type"
                    value={formik.values.login_type}
                    onChange={formik.handleChange}
                >
                    <MenuItem value="otp_based">OTP Based</MenuItem>
                    <MenuItem value="email&password">Credentials</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    Is COD Enabled
                </InputLabel>
                <Select
                    name="is_cod_enabled"
                    value={formik.values.is_cod_enabled}
                    onChange={formik.handleChange}
                >
                    <MenuItem value={'1'}>Yes</MenuItem>
                    <MenuItem value={'0'}>No</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    ycloud_key
                </InputLabel>
                <TextField
                    name="ycloud_key"
                    value={formik.values.ycloud_key}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={6}>
                <InputLabel className={globalClasses.inputLabel}>
                    is_gateway_enabled
                </InputLabel>
                <Select
                    name="is_gateway_enabled"
                    value={formik.values.is_gateway_enabled}
                    onChange={formik.handleChange}
                >
                    <MenuItem value={0}>Yes</MenuItem>
                    <MenuItem value={1}>No</MenuItem>
                </Select>
            </Grid>
        </Grid>
    </>
}

export default Configurations